import livestreamService from '../../services/livesession/LivestreamService';
import studentHighlightsService from '../../services/StudentHighlightsService';
import sessionReader from '../../store/readHelpers/SessionReader';
import settingsReader from '../../store/readHelpers/SettingsReader';
import liveSessioner from '../../services/livesession/LiveSessioner';
import uiService from '../../services/UIService';
import utilService from '../../services/UtilService';
import uiReader from '../../store/readHelpers/uiReader';
import { needsWebcam } from '../../services/HardwareRequirements';
import marketplacePropertiesService from '../../services/MarketplacePropertiesService';
import assessmentReader from '../../store/readHelpers/AssessmentReader';

const appSelector = {
    selectCallingProctorId(livestream) {
        return sessionReader.supportsLivestream() ? livestreamService.resolveCallingProctor(livestream) : undefined;
    },

    selectShouldShowLiveSessionCall(livestream, callingProctorId) {
        if (!callingProctorId) {
            return false;
        }

        const liveSessionTimestamp = livestreamService.resolveLiveSessionTimestamp(livestream, callingProctorId);
        return liveSessioner.hasAnyRemoteStream(callingProctorId, liveSessionTimestamp);
    },

    selectCurrentConnectionStatus(livestream, callingProctorId) {
        return callingProctorId ? livestreamService.resolveConnectionStatus(livestream, callingProctorId) : '';
    },

    selectClassList({ zoomFactor }, isNoteTakingAndHighlightingEnabled) {
        const classList = [zoomFactor || 'small'];

        if (settingsReader.isCopyPasteDisabled()) {
            classList.push('disable-select');
        }

        if ((isNoteTakingAndHighlightingEnabled && sessionReader.isAnnotationsSidebarOpen())
            || (settingsReader.isChatEnabled() && sessionReader.isChatOpen())) {
            classList.push('sidebarOpened');
        }

        if (sessionReader.isViewMediaPrintOrPdf()) {
            classList.push('view-media-print');
        }

        if (utilService.isPhantomJS()) {
            classList.push('phantom-js');
        }

        return classList;
    },

    selectAddTransition(isPaused, catTriggerInProgress) {
        return !sessionReader.isLayoutParamShowAnswerKeys() &&
            (isPaused || catTriggerInProgress || uiReader.useBackgroundAudioOverlay() || false);
    },

    selectShowSelectionContextMenu(studentHighlights, textToSpeech) {
        return (studentHighlights.hasValidSelection || (textToSpeech.hasValidSelection && textToSpeech.isEnabled));
    },

    selectIsStimulusHighlightingEnabled(sectionId) {
        return !!sectionId
            && settingsReader.isCandidateHighlightingEnabled()
            && !marketplacePropertiesService.isAnnotatingEnabled()
            && !!assessmentReader.getStimulusForSectionId(sectionId);
    },

    selectProps(state) {
        const {
            livestream,
            studentHighlights,
            textToSpeech,
            ui,
            currentlyShown: { routeType, sectionId },
            session: { mode, viewMedia } } = state;

        const callingProctorId = this.selectCallingProctorId(livestream);
        const isNoteTakingAndHighlightingEnabled = studentHighlightsService.isNoteTakingAndHighlightingEnabled();
        const catTriggerInProgress = sessionReader.isCatTriggerInProgress();
        const isPaused = sessionReader.isPaused();

        return {
            addTransition: this.selectAddTransition(isPaused, catTriggerInProgress),
            catTriggerInProgress,
            classList: this.selectClassList(ui, isNoteTakingAndHighlightingEnabled),
            currentlyShown: state.currentlyShown,
            footer: state.footer,
            isIOS: utilService.isIOS(),
            isNoteTakingAndHighlightingEnabled,
            isPaused,
            isStimulusHighlightingEnabled: this.selectIsStimulusHighlightingEnabled(sectionId),
            liveSessionConnectionStatus: this.selectCurrentConnectionStatus(livestream, callingProctorId),
            needsWebcam: needsWebcam(),
            passesLockDownRequirements: sessionReader.passesLockDownRequirements(),
            session: state.session,
            settings: state.settings,
            shouldShowLiveSessionCall: this.selectShouldShowLiveSessionCall(livestream, callingProctorId),
            showInvisibleNextButton: uiService.showInvisibleNextButton(routeType, mode, viewMedia),
            showSelectionContextMenu: this.selectShowSelectionContextMenu(studentHighlights, textToSpeech),
            time: state.time,
            ui,
        };
    },
};

export default appSelector;
